import React from 'react';
import AlertMessagge from "../alertMessagge/alertMessagge";
import Button from '../../../shared/components/atoms/Button/Button';
import './modalCoverage.scss';
import WarningIcon from '../../../shared/assets/images/icon-advertencia.svg';
import LayoutModal from '../../../shared/components/organisms/layoutModal/layout-modal';

const ModalCoverage = ({ hideAction, actionAlert }) => {
    
    return (
        <LayoutModal>
            <div className="f-alert-wrapper f-modal-coverage">
                <AlertMessagge
                    icon={<img src={WarningIcon} alt="warning-icon" />}
                    messagge="¡Lo sentimos!"
                    description="No tenemos cobertura en tu zona para que recibas la muestra gratis. Debes ingresar una dirección donde nuestra marca tenga cobertura."
                    type="primary"
                    button={<Button type="button" text="ACTUALIZAR MI DIRECCIÓN" onClickAction={ () => {actionAlert()} } classname="f-button f-button--primary" />} />
            </div>
        </LayoutModal>
    )
}

export default ModalCoverage;